const lbaLatLngMap = angular.module('app.lbaLatLngMap', []);

lbaLatLngMap.controller('lbaLatLngMapCtrl', require('./lbaLatLngMapCtrl'));
lbaLatLngMap.directive('lbaLatLngMap', require('./lbaLatLngMapDir'));

export default lbaLatLngMap;



// WEBPACK FOOTER //
// ./src/components/lbaLatLngMap/index.js